import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuardFxn } from './core/guards/auth.guard';
import { profileResolver } from './core/resolver/profile.resolver';
import { InvoicePayoutComponent } from './shared/components/invoice-payout/invoice-payout.component';
import { NotVerifiedComponent } from './core/common_components/not-verified/not-verified.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthComponent,
    resolve: {
      profile: profileResolver
    },
    // canActivate: [AuthGuardFxn],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./pages/auth/auth-route').then((m) => m.routes)
      }
    ]
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    resolve: {
      profile: profileResolver
    },
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/after-login-page/pages-route').then((m) => m.routes)
      }
    ]
  },
  {
    path: 'admin/invoice-payout',
    component: InvoicePayoutComponent
  },
  {
    path: 'not-verified',
    component: NotVerifiedComponent
  }
];

RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled'
});